import React from 'react';

interface PageHeaderAction {
  label: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  color?: string;
}

interface PageHeaderProps {
  icon: React.ReactNode;
  iconColor?: string;
  title: string;
  subtitle?: string;
  action?: PageHeaderAction;
}

export default function PageHeader({ icon, iconColor = '#6366f1', title, subtitle, action }: PageHeaderProps) {
  return (
    <div style={s.toolbar}>
      <div style={s.titleRow}>
        <div style={{ ...s.iconBox, background: iconColor }}>
          <span style={s.icon}>{icon}</span>
        </div>
        <div>
          <h2 style={s.title}>{title}</h2>
          {subtitle && <p style={s.subtitle}>{subtitle}</p>}
        </div>
      </div>

      {action && (
        <button
          style={{ ...s.btnAction, background: action.color ?? iconColor }}
          onClick={action.onClick}
          disabled={action.disabled}
        >
          {action.label}
        </button>
      )}
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  toolbar:  { display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 },
  titleRow: { display: 'flex', alignItems: 'center', gap: 14 },
  iconBox:  { width: 44, height: 44, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  icon:     { fontSize: 20, color: '#fff', display: 'flex', alignItems: 'center' },
  title:    { margin: 0, fontSize: 20, fontWeight: 700, color: '#0f172a' },
  subtitle: { margin: 0, fontSize: 12, color: '#64748b' },
  btnAction: {
    display: 'flex', alignItems: 'center', padding: '9px 18px',
    color: '#fff', border: 'none', borderRadius: 8,
    fontSize: 13, fontWeight: 600, cursor: 'pointer',
    opacity: 1, transition: 'opacity 0.15s',
  },
};
